<onyx-section
  [heading]="`${I18N}.heading`"
  [count]="pointsOfInterestControl.length"
>
  <form [formGroup]="form()">
    <onyx-dropdown
      [formControl]="form().controls.selectedPoints"
      [label]="`${I18N}.heading`"
      [options]="POINTS_OF_INTERES_SOURCE"
      [multiple]="true"
      [showAddOption]="true"
      addOptionMessage="labels.addNew"
      (selectedOptionValuesChange)="pointsOfInterest.set($event.values)"
      (addOption)="addPointOfInterest($event)"
      [size]="32"
    ></onyx-dropdown>

    <onyx-table
      [data]="pointsOfInterestControl.controls"
      [columns]="COLUMNS"
      [tableShadow]="false"
      [rowSize]="48"
      [rowOptions]="getPointOfInterestOptions"
      [notFound]="NOT_FOUND"
      [(pagination)]="pagination"
    ></onyx-table>
  </form>
</onyx-section>
